import React, { useEffect, useState } from "react";
import axios from "axios";
import AdminDashboard from "./Admindashboard";
import { API_BASE, THEMES } from "./config/themes";
import { authHeaders, getApiErrorMessage } from "./api/client";
import { canManageUsers } from "./utils/roles";
import { globalStyle } from "./utils/appStyles";

const adminTheme = THEMES.tobe_staff || THEMES.general;

function AdminApp() {
  const [checking, setChecking] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [loginData, setLoginData] = useState({ userid: "", password: "" });
  const [error, setError] = useState("");
  const [pendingApprovalCount, setPendingApprovalCount] = useState(0);

  const loadCurrentUser = async () => {
    try {
      const res = await axios.get(`${API_BASE}/me`, { headers: authHeaders() });
      const user = res.data?.user || res.data || null;
      if (!canManageUsers(user?.role)) {
        localStorage.removeItem("token");
        setError("관리자 권한이 있는 계정만 접속할 수 있습니다.");
        setIsLoggedIn(false);
        setCurrentUser(null);
        return;
      }
      setCurrentUser(user);
      setIsLoggedIn(true);
    } catch (err) {
      localStorage.removeItem("token");
      setIsLoggedIn(false);
      setCurrentUser(null);
    } finally {
      setChecking(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      loadCurrentUser();
    } else {
      setChecking(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogin = async (event) => {
    event.preventDefault();
    setError("");
    try {
      const res = await axios.post(`${API_BASE}/login`, {
        userid: loginData.userid.trim(),
        password: loginData.password,
      });
      const user = res.data?.user;
      if (!canManageUsers(user?.role)) {
        setError("관리자 권한이 있는 계정만 접속할 수 있습니다.");
        return;
      }
      localStorage.setItem("token", res.data?.token);
      setCurrentUser(user);
      setIsLoggedIn(true);
    } catch (err) {
      setError(getApiErrorMessage(err, "관리자 로그인 정보를 확인해 주세요."));
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
    setCurrentUser(null);
    setLoginData({ userid: "", password: "" });
    setPendingApprovalCount(0);
  };

  if (checking) {
    return (
      <div className="auth-page admin-auth-page">
        <style>{globalStyle(adminTheme)}</style>
        <div className="auth-card">
          <h1>TOBE <span>ADMIN</span></h1>
          <p className="auth-subtitle">관리자 권한을 확인하는 중입니다.</p>
        </div>
      </div>
    );
  }

  if (!isLoggedIn) {
    return (
      <div className="auth-page admin-auth-page">
        <style>{globalStyle(adminTheme)}</style>
        <form className="auth-card" onSubmit={handleLogin}>
          <h1>TOBE <span>ADMIN</span></h1>
          <p className="auth-subtitle">관리자 앱은 별도 접속 화면에서만 사용할 수 있습니다.</p>
          <input
            className="auth-input"
            placeholder="관리자 아이디"
            value={loginData.userid}
            onChange={(event) => setLoginData({ ...loginData, userid: event.target.value })}
          />
          <input
            className="auth-input"
            type="password"
            placeholder="비밀번호"
            value={loginData.password}
            onChange={(event) => setLoginData({ ...loginData, password: event.target.value })}
          />
          {error && <div className="auth-error">{error}</div>}
          <button type="submit" className="btn-auth">관리자 로그인</button>
          <p className="auth-toggle" onClick={() => { window.location.href = "/"; }}>
            사용자 앱으로 이동
          </p>
        </form>
      </div>
    );
  }

  return (
    <div className="app-shell admin-app-shell">
      <style>{globalStyle(adminTheme)}</style>
      <main className="main-content admin-main-content">
        <header className="topbar">
          <div className="topbar-left">
            <h3>TOBE 관리자 앱</h3>
          </div>
          <div className="topbar-right">
            <span className="admin-session-label">
              {currentUser?.name || currentUser?.userid} · 대기 {pendingApprovalCount}
            </span>
            <button className="tts-ready-button" onClick={() => { window.location.href = "/codex"; }}>🚀 Codex 작업실</button>
            <button className="tts-ready-button" onClick={() => { window.location.href = "/"; }}>사용자 앱</button>
            <button className="tts-ready-button" onClick={handleLogout}>로그아웃</button>
          </div>
        </header>
        <AdminDashboard
          apiBase={API_BASE}
          token={localStorage.getItem("token") || ""}
          onPendingCountChange={setPendingApprovalCount}
          currentUser={currentUser}
        />
      </main>
    </div>
  );
}

export default AdminApp;
